export enum TransactionType {
  INCOME = "RECEITA",
  EXPENSE = "DESPESA",
  ADJUSTMENT = "AJUSTE"
}
